import { Link } from 'react-router-dom';
import SiteContacts from '../components/SiteContacts';

export default function MiniGroupsPage() {
  return (
    <article className="legal-page offer-page">
      <header className="legal-page-header">
        <h1>Индивидуализированные мини-группы</h1>
        <p className="legal-page-nav">
          <Link to="/kak">Как устроены занятия на сайте</Link>
        </p>
        <p className="offer-lead">
          Подготовка к ЕГЭ / ОГЭ по информатике — это, прежде всего, выработка
          устойчивого навыка решения задач. На экзамене ученик остаётся один на
          один с заданиями, и от его способности самостоятельно заметить ошибку,
          перепроверить решение и вовремя скорректировать ход мыслей зависит
          итоговый балл.
        </p>
      </header>

      <div className="legal-page-body">
        <p>
          В индивидуальных занятиях я часто сталкиваюсь с дилеммой: дать ученику
          подумать дольше — или подсказать, чтобы успеть пройти все темы. Если я
          показываю ошибку слишком рано, ученик привыкает к внешнему контролю.
          Если даю думать слишком долго — теряем время, которого всегда не
          хватает. Домашние задания частично решают проблему, но там ученик
          остаётся один, и если у него что-то не получается, процесс
          затягивается, а запоминание правильного решения сдвигается на следующий
          день, что снижает эффективность.
        </p>

        <h2>Что предлагаю я</h2>
        <p>
          Я собрал формат, который сохраняет все преимущества индивидуальной
          работы, но при этом:
        </p>
        <ul>
          <li>стоит заметно дешевле,</li>
          <li>даёт больше времени на самостоятельное размышление,</li>
          <li>не требует ждать, пока другие ученики поймут тему.</li>
        </ul>
        <p>
          В группе занимаются 2–4 человека. Каждый ученик работает по своему
          индивидуальному плану и решает свои собственные задачи — никаких общих
          лекций и синхронного прохождения тем.
        </p>

        <h2>Как проходит занятие</h2>
        <p>
          Я даю одному ученику задачу. Он читает условие, начинает писать
          программу или выполнять расчёты.
        </p>
        <p>
          Пока он думает, я переключаюсь к другому ученику — разбираю его
          вопросы, проверяю его решение, помогаю найти ошибку.
        </p>
        <p>
          Когда первый ученик завершил или застрял, я возвращаюсь к нему. Я не
          даю готовый ответ сразу — я задаю наводящие вопросы, показываю, где
          искать нестыковку, чтобы он сам пришёл к правильному решению.
        </p>
        <p>
          Таким образом, каждый ученик получает моё внимание ровно в тот момент,
          когда оно действительно нужно. При этом между моими «подходами» ученик
          вынужден дольше обдумывать задачу самостоятельно — и это очень полезно.
          Именно в эти минуты формируется та самая внутренняя проверка, которая
          так важна на экзамене.
        </p>
        <p>
          А если ученик застрял, а я пока занят с другим, он не сидит без дела: я
          предлагаю короткие тренажёры или тесты по смежной теме. Так время
          используется максимально эффективно, и никто не ждёт впустую.
        </p>

        <h2>Главные преимущества этого формата</h2>
        <ul>
          <li>
            <strong>Никакого «общего темпа».</strong> Каждый идёт со своей
            скоростью, никто ни от кого не отстаёт и не ждёт.
          </li>
          <li>
            <strong>Нет социального дискомфорта.</strong> Не стыдно переспросить
            десятый раз, не нужно бояться, что другие ученики осудят — вы
            общаетесь только со мной.
          </li>
          <li>
            <strong>Гибкое расписание.</strong> Так как у каждого свой план, вы
            можете перенести занятие на другой день или присоединиться к другой
            группе — главное, чтобы было свободное место. Вы не привязаны к
            жёсткому графику.
          </li>
          <li>
            <strong>Больше времени за те же деньги.</strong> Стоимость группового
            занятия ниже индивидуального, а продолжительность я рекомендую брать
            90 или 120 минут — за ту же сумму вы получаете на 30–60 минут больше
            работы в неделю.
          </li>
        </ul>

        <h2>Сколько это стоит</h2>
        <table className="offer-prices">
          <thead>
            <tr>
              <th scope="col">Длительность</th>
              <th scope="col">Стоимость</th>
              <th scope="col">В час</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>60 минут</td>
              <td>1{'\u00a0'}800{'\u00a0'}₽</td>
              <td>1{'\u00a0'}800{'\u00a0'}₽</td>
            </tr>
            <tr>
              <td>90 минут</td>
              <td>2{'\u00a0'}400{'\u00a0'}₽</td>
              <td>1{'\u00a0'}600{'\u00a0'}₽</td>
            </tr>
            <tr>
              <td>120 минут</td>
              <td>3{'\u00a0'}000{'\u00a0'}₽</td>
              <td>1{'\u00a0'}500{'\u00a0'}₽</td>
            </tr>
          </tbody>
        </table>
        <p>
          Для сравнения: моя индивидуальная ставка — 2{'\u00a0'}500{'\u00a0'}₽/час.
          В группе вы экономите от 28% до 40% за каждый час, при этом по сути
          получаете почти индивидуальное сопровождение.
        </p>

        <h2>Что в итоге</h2>
        <p>
          Вы не переплачиваете за «общие слова» и не теряете время в ожидании
          других. Вы много практикуетесь, учитесь находить ошибки самостоятельно,
          но всегда имеете возможность получить помощь именно в тот момент, когда
          она нужна. Это и есть самый надёжный путь к высокому баллу на экзамене.
        </p>

        <h2>Записаться</h2>
        <p>Напишите — подберём группу и время.</p>
        <SiteContacts variant="card" />
      </div>
    </article>
  );
}
